export { default as ImageCta } from './ImageCta';
